import { render, staticRenderFns } from "./pdfpreview.vue?vue&type=template&id=79d88c90"
import script from "./pdfpreview.vue?vue&type=script&lang=js"
export * from "./pdfpreview.vue?vue&type=script&lang=js"
import style0 from "./pdfpreview.vue?vue&type=style&index=0&id=79d88c90&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d88c90')) {
      api.createRecord('79d88c90', component.options)
    } else {
      api.reload('79d88c90', component.options)
    }
    module.hot.accept("./pdfpreview.vue?vue&type=template&id=79d88c90", function () {
      api.rerender('79d88c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/pdfpreview.vue"
export default component.exports